export const types = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  CATEGORIES: 'CATEGORIES',
  RANGE: 'RANGE',
  YES_OR_NO: 'YES_OR_NO',
};
